import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { ProductVisual } from './ProductVisual';
import { CHECKOUT_URL } from '../data/product';
const included = ['6 volumes · 300 landscape pages', '134 ready-to-run sessions', 'Every session at 3 levels · students, clubs, adults', '42 printable worksheets + 180 prompts', '5 bonuses, incl. the Master Session Finder', 'Lifetime access to your files'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="w-full bg-cloud text-ink" data-id="element-205" data-mp="1rtrnzet051hq">
      <div className="max-w-2xl mx-auto px-5 py-16 sm:py-20" data-id="element-206" data-mp="25t0shh7ui75v">
        <div className="text-center" data-id="element-207" data-mp="20tej5iv51b2c">
          <p className="text-[11px] font-semibold uppercase tracking-[1.6px] text-coral-deep" data-id="element-208" data-mp="20sd12ufpfob4">Complete package</p>
          <h2 id="pricing-heading" className="mt-3 font-display text-3xl font-extrabold text-ink sm:text-5xl" data-id="element-209" data-mp="3h5jsozzy0ge4">
            Your whole speaking year, planned
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl border border-cloud-dark bg-white shadow-soft" data-id="element-210" data-mp="3vyxac8bw0ej9">
          <div className="bg-ink px-5 py-5 text-center" data-id="element-211" data-mp="4rkubwmqq74x">
            <h3 className="font-display text-lg font-extrabold tracking-tight text-white sm:text-2xl" data-id="element-212" data-mp="9rpcdr3ar9x9">52 Weeks of Speaking — Complete Package</h3>
            <p className="mt-1 text-[13px] font-semibold uppercase tracking-widest text-amber" data-id="element-213" data-mp="eqk119ny3spa">6 Volumes + 5 Bonuses</p>
          </div>
          <div className="wave-strip h-1.5 w-full" aria-hidden="true" data-id="element-214" data-mp="3i7si3raumoiy" />

          <div className="p-5 sm:p-7" data-id="element-215" data-mp="3i5xx6czkuwev">
            <div id="offer" className="scroll-mt-4" data-id="element-216" data-mp="3n6ljilcv2p2r">
              <ProductVisual lazy className="w-full shadow-none" data-id="element-217" data-mp="3n523mvv4ag1i" />
            </div>

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-218" data-mp="3rzeonac8rzfd">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-sm text-ink" data-id="element-219" data-mp="2ui7ma7tljws9">
                  <span className="mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-teal" data-id="element-220" data-mp="2zg9d5ex9l0ea">
                    <CheckIcon className="h-3 w-3 text-white" aria-hidden="true" data-id="element-221" data-mp="2res042aqgovt" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t border-cloud-dark pt-6 text-center" data-id="element-222" data-mp="315wep0why7q4">
              <p className="text-[13px] text-slate" data-id="element-223" data-mp="2w8w9es7h1902">
                Total value <span className="line-through" data-id="element-224" data-mp="28hh2em4r23ih">$97 USD</span>
              </p>
              <div className="mt-1 flex items-start justify-center gap-1 text-ink" data-id="element-225" data-mp="28jtrdj8xde51">
                <span className="mt-2.5 font-display text-3xl font-extrabold" data-id="element-226" data-mp="23l0gzzoxq393">$</span>
                <span className="font-display text-[56px] font-extrabold leading-[0.9] sm:text-7xl" data-id="element-227" data-mp="2ihhougxx0zqw">27</span>
                <span className="mt-3 text-[13px] font-semibold text-slate" data-id="element-228" data-mp="2dj6f067mep8o">USD</span>
              </div>

              <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-229" data-mp="3txg10toe41wc">
                <span className="rounded-full bg-amber px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-ink" data-id="element-230" data-mp="3ovqplcx99m7q">Save $70</span>
                <span className="rounded-full border border-cloud-dark px-2.5 py-1 text-[10px] font-semibold uppercase tracking-widest text-slate" data-id="element-231" data-mp="59grygepa9tm">One-time payment</span>
                <span className="rounded-full border border-cloud-dark px-2.5 py-1 text-[10px] font-semibold uppercase tracking-widest text-slate" data-id="element-232" data-mp="3ngwe8c2los61">No app, no subscription</span>
              </div>

              <p className="mt-4 text-[13px] text-slate" data-id="element-233" data-mp="j1n5duqgy2pd">That&apos;s about 52 cents a week — for the whole year.</p>

              <CtaButton href={CHECKOUT_URL} className="mt-4" data-id="element-234" data-mp="o1srkvdyyx02">
                Get 52 Weeks of Speaking — only $27
              </CtaButton>

              <p className="mt-3 text-xs text-slate" data-id="element-235" data-mp="e9d7nsj43ycj">Backed by the 7-day money-back guarantee</p>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-slate" data-id="element-236" data-mp="11zhahxoh7u2h">
                <li className="flex items-center gap-1.5" data-id="element-237" data-mp="16rhf43fhrb5e">
                  <LockIcon className="h-4 w-4 text-teal-deep" aria-hidden="true" data-id="element-238" data-mp="3f78t0fsq3hg8" />
                  Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-239" data-mp="3a7e5mm85p9zx">
                  <ZapIcon className="h-4 w-4 text-teal-deep" aria-hidden="true" data-id="element-240" data-mp="3592sa1inkhcy" />
                  Access in 5 minutes
                </li>
                <li className="flex items-center gap-1.5" data-id="element-241" data-mp="3192e8hzgu86f">
                  <ShieldCheckIcon className="h-4 w-4 text-teal-deep" aria-hidden="true" data-id="element-242" data-mp="1scj5drrxo71" />
                  7-day guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-slate" data-id="element-243" data-mp="3o7oszfa9c6gc">Price in USD. You&apos;ll be charged the equivalent in your local currency.</p>
      </div>
    </section>;
}